/**
 * Widget that handles adding a description to the page.  Automatically knows whether to hide the description
 * based on the value of the corresponding user setting.
 *
 * supports static and key bindings (key.js)
 */
import locale from "common/managers/locale";
import userSettings from "common/managers/userSettings";
import UserSettingNames from "common/enums/settings/UserSettingNames";
import topic from "common/managers/topic";
import Message from "common/enums/main/Message";
import "common/bindings/key";

const Description = kendo.ui.Widget.extend({
    options: {
        name: "Description",

        /**
         * A locale key that should back the widget. can be set by setOptions()
         */
        key: "",

        /**
         * Static text that should be displayed in the widget. Can be set by setOptions()
         */
        static: ""
    },

    _topicInstance: undefined,

    init: function(element, options) {
        kendo.ui.Widget.fn.init.apply(this, arguments);

        this.wrapper = this.element;

        // listen for the appropriate user setting
        this._topicInstance = topic.subscribe(Message.USER_SETTING_CHANGED, $.proxy(this.handleSettingChanged, this));

        // initial toggle operation
        this._toggle();
    },

    _getText: function() {
        if (!!this.options.key) {
            return locale.get(this.options.key);
        } else {
            return this.options.static;
        }
    },

    _toggle: function() {

        // determine whether the user setting is enabled, default to true for non-existent settings.
        // if enabled, look up localized text and render a <p><span> combo.
        // if disabled, hide the target element
        var text = this._getText();
        if (userSettings.getBoolean(UserSettingNames.SHOW_HEADER_DESCRIPTIONS, true) && !!text) {
            $(this.element)
                .removeClass("hide")
                .addClass("descriptionText")
                .text(text);
        } else {
            $(this.element).addClass("hide");
        }
    },

    setOptions: function() {
        kendo.ui.Widget.fn.setOptions.apply(this, arguments);
        this._toggle();
    },

    /**
     * Handle user settings being updated.  If the updated settings include showing header descriptions, toggle.
     * @param settings an array of updated setting names
     */
    handleSettingChanged: function(settings) {
        if (settings.indexOf(UserSettingNames.SHOW_HEADER_DESCRIPTIONS) > -1) {
            this._toggle();
        }
    },

    destroy: function() {
        topic.unsubscribe(this._topicInstance);
        kendo.ui.Widget.fn.destroy.apply(this, arguments);
    }
});
kendo.ui.plugin(Description);
export default Description;
